import React from 'react'
import { CustomShiftNotificationsProvider } from './context/CustomShiftNotificationsProvider'
import { CustomShiftNotificationsMain } from './components/CustomShiftNotificationsMain'

export const CustomShiftNotifications = () => (
  <CustomShiftNotificationsProvider>
    <CustomShiftNotificationsMain />
  </CustomShiftNotificationsProvider>
)
